var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chartItem"},[_c('el-tabs',{on:{"tab-click":_vm.handleClick},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"媒介类型统计","name":"1"}},[_c('div',{staticClass:"chartBox",attrs:{"id":"chartBox5"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }